<template>
	    <div id="content" class="flex ">
	    <!-- ############ Main START-->
	    <div>
	        <div class="page-hero page-container " id="page-hero">
				<div class="padding" v-if="notification.message">
					<div class="alert alert-dismissible fade show" :class="{ ['alert-' + notification.class]: true }" role="alert"> 
						{{notification.message}}
					</div>
				</div>
	            <div class="padding d-flex">
	                <div class="page-title">
	                    <h2 class="text-md text-highlight">Settings</h2>
	                    <!--<small class="text-muted">By letting us know your personal info, we can make your support experience much more personal</small>-->
	                </div>
	            </div>
	        </div>
	        <div class="page-content page-container" id="page-content">
	            <div class="padding">
	                <div id="accordion">
	                    <p class="text-muted">
	                        <strong>Account</strong>
	                    </p>
	                    <div class="card">
	                        <div class="d-flex align-items-center px-4 py-3 pointer" data-toggle="collapse" data-parent="#accordion" data-target="#c_1">
	                            <div>
	                                <span class="w-48 avatar circle bg-info-lt" data-toggle-class="loading"><img src="../../static/assets/img/a9.jpg" alt="."></span>
	                            </div>
	                            <div class="mx-3 d-none d-md-block">
	                                <strong>{{this.username}}</strong>
	                                <div class="text-sm text-muted">{{this.email}}</div>
	                            </div>
	                            <div class="flex"></div>
	                            <!--
	                            <div class="mx-3">
	                                <chevron-right-icon class="custom-class" width="16" height="16"></chevron-right-icon>
	                            </div>-->
	                        </div>
	                        <!--
	                        <div class="collapse p-4" id="c_1">
	                            <form role="form">
	                                <div class="form-group">
	                                    <label>Profile picture</label>
	                                    <div class="custom-file">
	                                        <input type="file" class="custom-file-input" id="customFile">
	                                        <label class="custom-file-label" for="customFile">Choose file</label>
	                                    </div>
	                                </div>
	                                <div class="form-group">
	                                    <label>First Name</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <div class="form-group">
	                                    <label>Last Name</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <div class="form-group">
	                                    <label>Email Address</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <button type="submit" class="btn btn-primary mt-2">Update</button>
	                            </form>
	                        </div> -->
	                        <!--
	                        <div class="d-flex align-items-center px-4 py-3 b-t">
	                            <refresh-cw-icon class="custom-class" width="16" height="16"></refresh-cw-icon>
	                            <div class="px-3">
	                                <div>Sync</div>
	                                <div class="text-sm text-muted">On - Sync everything</div>
	                            </div>
	                            <div class="flex"></div>
	                                <span>
	                                    <label class="ui-switch ui-switch-md">
	                                      <input type="checkbox" checked>
	                                      <i></i>
	                                    </label>
	                                </span>
	                        </div> -->
	                        <div class="d-flex align-items-center px-4 py-3 b-t pointer" data-toggle="collapse" data-parent="#accordion" data-target="#c_2">
	                           <lock-icon class="custom-class" width="16" height="16"></lock-icon>
	                            <div class="px-3">
	                                <div>Password Change</div>
	                            </div>
	                            <div class="flex"></div>
	                            <div>
	                                <chevron-right-icon class="custom-class" width="16" height="16"></chevron-right-icon>
	                            </div>
	                        </div>
	                        <div class="collapse p-4" id="c_2">
	                            <form role="form" @submit.prevent="changePassword">
	                                <div class="form-group">
	                                    <label>Old Password</label>
										<input type="password" v-model="oldPassword" class="form-control" required>
	                                </div>
	                                <div class="form-group">
	                                    <label>New Password</label>
	                                    <input type="password" @change="validatePassword"  v-model="newPassword" class="form-control" required>
	                                </div>
	                                <div class="form-group">
	                                    <label>New Password Again</label>
	                                    <input ref="confirm-password" @keyup="validatePassword" v-model="newPasswordAgain" type="password" class="form-control" required>
	                                </div>
	                                <button type="submit" class="btn btn-primary mt-2" >Set Password</button>
	                            </form>
	                        </div>
	                      
	                      	<!--
	                        <div class="d-flex align-items-center px-4 py-3 b-t pointer" data-toggle="collapse" data-parent="#accordion" data-target="#c_4">
	                            <map-pin-icon class="custom-class" width="16" height="16"></map-pin-icon>
	                            <div class="px-3">
	                                <div>Addresses, phone and more</div>
	                            </div>
	                            <div class="flex"></div>
	                            <div>
	                                <chevron-right-icon class="custom-class" width="16" height="16"></chevron-right-icon>
	                            </div>
	                        </div> -->
	                        <!--
	                        <div class="collapse p-4" id="c_4">
	                            <form role="form">
	                                <div class="form-group">
	                                    <label>URL</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <div class="form-group">
	                                    <label>Company</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <div class="form-group">
	                                    <label>Location</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <div class="form-group">
	                                    <label>Phone number</label>
	                                    <input type="text" class="form-control">
	                                </div>
	                                <button type="submit" class="btn btn-primary mt-2">Update</button>
	                            </form>
	                        </div> -->
	                    </div>

	                    <!--
	                    <p class="text-muted">
	                        <strong>Security</strong>
	                    </p>
	                    <div class="card">
	                        <div class="d-flex align-items-center px-4 py-3 b-t pointer" data-toggle="collapse" data-parent="#accordion" data-target="#c_5">
	                            <div>Delete account?</div>
	                            <div class="flex"></div>
	                            <div>
	                                <chevron-right-icon class="custom-class" width="16" height="16"></chevron-right-icon>
	                            </div>
	                        </div>
	                        <div class="collapse p-4" id="c_5">
	                            <div class="py-3">
	                                <p>Are you sure to delete your account?</p>
	                                <button type="button" class="btn btn-white">No</button>
	                                <button type="button" class="btn btn-danger">Yes</button>
	                            </div>
	                        </div>
	                    </div> -->
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- ############ Main END-->
	</div>
</template>


<script type="text/javascript">
import {ChevronRightIcon, RefreshCwIcon, LockIcon, MapPinIcon} from 'vue-feather-icons';
import {getUser} from '@/utils/auth';


export default{
	name: 'AccountSettings',
	components:{
		ChevronRightIcon,
		RefreshCwIcon,
		LockIcon,
		MapPinIcon
	},
	data() {
		return {
			username: '',
			email: '',
			notification: {message: '', class:''},

			oldPassword: '',
			newPassword: '',
			newPasswordAgain: '',
		}; 
	},
	methods: {
		changePassword() {
            const path = process.env.API_LOCATION + `/change_password`;
            
            this.$http.post(path, {
				email: this.email,
				oldPassword: this.oldPassword,
				newPassword: this.newPassword,
			})
            .then(response => {
				this.notification.class = "success";
				this.notification.message = "Successfully changed password!";
            })
            .catch(error => {
				this.notification.class = "danger";
				this.notification.message = 
					error.response.data.errors[0] || "Unable to change password at the moment.";
			})
			.finally(() => {
				setTimeout(() => {
					this.notification.message = "";
					this.notification.class = "";
				}, 5000);
			})
		},
		
		validatePassword(){
			const el = this.$refs["confirm-password"];
			if(this.newPassword!=this.newPasswordAgain)
				el.setCustomValidity("Passwords Don't Match");
			else
				el.setCustomValidity('');		
		}
	},
  	mounted(){
  		getUser().then(response =>{
  			var user = response.data;
  			this.username = user['name'];
  			this.email = user['email']
  		})
  		.catch(error => {
  			console.log(error)
  		})
  },

};  

</script>        



// WEBPACK FOOTER //
// src/components/AccountSettings.vue